/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ContentManagementRetryCreateContentResponse } from './ContentManagementRetryCreateContentResponse';

export type ContentManagementRetryCreateContentResponseApiRespoonse = {
    data?: ContentManagementRetryCreateContentResponse;
    status?: ContentManagementRetryCreateContentResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ContentManagementRetryCreateContentResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

